import { render, staticRenderFns } from "./MainRecentCar.vue?vue&type=template&id=5102cacb&scoped=true&"
import script from "./MainRecentCar.vue?vue&type=script&lang=js&"
export * from "./MainRecentCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102cacb",
  null
  
)

export default component.exports